// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"2c6bff70","450":"f9ad44ac","453":"eca5f793","884":"b0edbd8f"}[chunkId] + ".chunk.js";
};